import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@sr/ui-library';
import { Control } from 'react-hook-form';
import * as yup from 'yup';
import { CountryCombobox } from '../../shared/CountryCombobox';
import { WORKSPACE_DETAILS_FORM_FIELDS } from '../../shared/fieldNames';
import { WorkspaceDetailsFormValues } from '../../shared/types';

interface BusinessNumberCountryFieldProps {
  control: Control<WorkspaceDetailsFormValues>;
  disabled?: boolean;
}

export const BusinessNumberCountryField = ({
  control,
  disabled,
}: BusinessNumberCountryFieldProps) => (
  <FormField
    name={WORKSPACE_DETAILS_FORM_FIELDS.businessNumberCountry}
    control={control}
    render={({ field }) => (
      <FormItem>
        <FormLabel
          asterisk
          tooltipContent="Select the country where your business is registered."
        >
          Business Number Country
        </FormLabel>
        <FormControl>
          <CountryCombobox
            disabled={disabled}
            field={field}
            placeholder="Select a country"
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
);

BusinessNumberCountryField.schema = yup
  .string()
  .required('Please select a Country');
